export default {
  personal: 'Pessoal',
  autonomous: 'Autônomo',
  mei: 'MEI',
  enterprise: 'Empresa'
}